'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReactMultiChild = require('react/lib/ReactMultiChild');

var _ReactMultiChild2 = _interopRequireDefault(_ReactMultiChild);

var _ReactKonsulIDOperations = require('./ReactKonsulIDOperations');

var _ReactKonsulIDOperations2 = _interopRequireDefault(_ReactKonsulIDOperations);

var _konsul = require('./utils/konsul');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalCounter = 1;

var ReactKonsulComponent = function ReactKonsulComponent(element) {
  this._rootNodeID = null;
  this._domID = null;
  this._mountImage = null;
  this._mountIndex = 0;
  this._currentElement = element;
  this._node = null;
  this._hostContainerInfo = null;
  this._hostParent = null;
  this._renderedChildren = null;
};

var ReactKonsulComponentMixin = {
  mountComponent: function mountComponent(transaction, parent, containerInfo, context) {
    this._rootNodeID = globalCounter++;
    this._domID = containerInfo._idCounter++;
    this._hostParent = parent;
    this._hostContainerInfo = containerInfo;

    var node = this.mountNode(parent, this._currentElement);
    node.setOrder(this._domID);
    this._node = node;

    var children = this._currentElement.props.children;
    this.mountChildren(children, transaction, context);
    this.updateChildrenIndex(children);

    return node;
  },
  updateChildrenIndex: function updateChildrenIndex(children) {},
  mountNode: function mountNode(parent, node) {
    var konsul = _ReactKonsulIDOperations2.default.konsul;
    var element = (0, _konsul.makeElement)(node, konsul);

    (0, _konsul.applyProps)(element, node);
    var parentElement = _ReactKonsulIDOperations2.default.getParent(parent);

    element.parent = parentElement;
    parentElement.append(element);

    _ReactKonsulIDOperations2.default.add(this._rootNodeID, element);

    return element;
  },
  receiveComponent: function receiveComponent(nextElement, transaction, context) {
    var konsul = _ReactKonsulIDOperations2.default.konsul;
    var prevElement = this._currentElement;
    this._currentElement = nextElement;

    var node = this.getPublicInstance();

    var children = nextElement.props.children;
    var childrenToUse = children === null ? [] : [].concat(children);

    (0, _konsul.applyProps)(node, nextElement, prevElement);

    this.updateChildren(childrenToUse, transaction, context);

    konsul.debounceRender();
  },
  getPublicInstance: function getPublicInstance() {
    return this._node;
  },
  getHostNode: function getHostNode() {
    return this._currentElement;
  },
  unmountComponent: function unmountComponent() {
    this.getPublicInstance().destroy();
  }
};

Object.assign(ReactKonsulComponent.prototype, ReactKonsulComponentMixin, _ReactMultiChild2.default.Mixin);

exports.default = ReactKonsulComponent;


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/ReactKonsulComponent.js
// module id = 678
// module chunks = 0